import React, { /*useContext,*/ useEffect, useState } from 'react';
import { Container, Box, Button, TextField , TableContainer, Table, TableHead,TableRow, TableCell, TableBody } from '@mui/material';
//import { useNavigate } from 'react-router-dom';
//import { AuthContext } from '../context/AuthContext';
import MenuAppBar from '../components/MenuAppBar';
import MenuBottAppBar from '../components/MenuBottAppBar';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from "axios";

const EnergieDataDenEntity = () => {
  //const { logout, role } = useContext(AuthContext);
  //const navigate = useNavigate();

  const [today, setToday] = useState(dayjs(new Date().toISOString().slice(0, 10)));
  const [data, setData] = useState([]);
  const [datavcera, setDatavcera] = useState([]);
  //const [selectedRow, setSelectedRow] = useState(null);
  
  const [loading, setLoading] = useState(true);
  //const [error, setError] = useState(null);
  const [sneckmessage, setSneckmessage] = useState(null);
  const [opensneckmessage, setOpensneckmessage] = useState(false);
  
  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}` };
  };
  
  const getSpotrebavcera = (idenergieentita) => {
    return datavcera.find(item => item.idenergieentita === idenergieentita);
  };

  const saveRow = async (index) => {
    try {
      const rowData = data[index]; // Získání upraveného řádku
      //console.log("Ukládám řádek:", rowData);
  
      // Odeslání na server (upravit podle API)
      await axios.post("/api/energie/entitydendata", rowData, { headers: getAuthHeaders() });

      /*let sortedData = [...data].sort((a, b) => {
        (b.spotreba > a.spotreba) ? 1 : -1;
      });
      setData(sortedData);*/

      data.sort((a, b) => b.spotreba - a.spotreba);
      setData([...data]);

      setSneckmessage("Úspěšně uloženo!");
      setOpensneckmessage(true);
  
      //alert("Úspěšně uloženo!");
    } catch (error) {
      //console.error("Chyba při ukládání:", error);
      alert("Chyba při ukládání dat.");
    }
  };
  
  useEffect(() => {

    const fetchData = async () => {
      /*const data0 = await axios.get("/api/energie/roky", { headers: getAuthHeaders(), params:{}});
      const roky = [];
      data0.data.forEach(element => {
        roky.push(element.rok);
      });
      setRoky(roky);

      const data1 = await axios.get("/api/energie/obdobi", { headers: getAuthHeaders(), params:{"rok":rok}});
      setObdobi(data1.data);*/
      
      const entData = await axios.get("/api/energie/entitydendata", { headers: getAuthHeaders(), params:{"today":today.format("").slice(0, 10)}});
      setData(entData.data.energieentitaspotrden);
      setDatavcera(entData.data.energieentitaspotrdenvcera);

      setLoading(false);

    };

    fetchData();
    //loadData(actrok, actobdobi);

  }, [today]);

  const handleChangeLast = (index, ev) => {
    const newValue = ev.target.value;
    setData(prevData => 
      prevData.map((item, i) => 
        i === index ? { ...item, spotrebalast: parseFloat(newValue) } : item
      )
    );
  };
  const handleChangeDen = (index, ev) => {
    const newValue = ev.target.value;
    setData(prevData => 
      prevData.map((item, i) => 
        i === index ? { ...item, spotrebaden: parseFloat(newValue) } : item
      )
    );
  };

  const handleKeyUp = (index, ev) => {
    if (ev.key === 'Enter') {
      saveRow(index);
    }
  };

  const handleClosesneckmessage = () => {
    //setState({ ...state, open: false });
    setOpensneckmessage(false);
  };

  if (loading) return <p>Načítání...</p>;
  //if (error) return <p>Chyba: {error}</p>;
  

  return (
    
    <Container>
    <MenuAppBar title='Energie - Data entity' />
    <Box> </Box>
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Zvolené datum"
          value={today}
          onChange={(newValue) => setToday(newValue)}
        />
    </LocalizationProvider>
    </Box>
    <Box>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Entita</TableCell>
            <TableCell>Spotřeba den</TableCell>
            <TableCell>Spotřeba last</TableCell>
            <TableCell>Spotřeba vcera last</TableCell>
            <TableCell>Spotřeba calc</TableCell>
            
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={row.idenergieentitaspotrobd}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <TextField
                  disabled
                  value={row.EnergieEntita.entita}
                />
              </TableCell>
              <TableCell align="right">
                <TextField
                fullWidth
                variant="outlined"
                type="number"
                id={"fld-spotrebaden-"+row.idenergieentitaspotrden}
                value={row.spotrebaden}
                onChange={(e) => handleChangeDen(index, e)}
                onKeyPress={(e) => handleKeyUp(index, e)}
                onClick={(e) => e.target.select()}
                />
              </TableCell>
              
              <TableCell align="right">
                <TextField
                fullWidth
                variant="outlined"
                type="number"
                id={"fld-spotrebalast-"+row.idenergieentitaspotrden}
                value={row.spotrebalast}
                onChange={(e) => handleChangeLast(index, e)}
                onKeyUp={(e) => handleKeyUp(index, e)}
                onClick={(e) => e.target.select()}
                />
              </TableCell>
              
              <TableCell align="right">
                <TextField
                disabled
                fullWidth
                variant="outlined"
                type="number"
                id={"fld-spotrebavceralast-"+row.idenergieentitaspotrden}
                value={getSpotrebavcera(row.idenergieentita).spotrebalast}
                />
              </TableCell>

              <TableCell align="right">
                <TextField
                disabled
                fullWidth
                variant="outlined"
                type="number"
                id={"fld-spotrebacalc-"+row.idenergieentitaspotrden}
                value={(row.spotrebalast-getSpotrebavcera(row.idenergieentita).spotrebalast).toFixed(2)}
                />
              </TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Box>
    {sneckmessage && (
    <Snackbar
      open={opensneckmessage}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={1000}
      onClose={handleClosesneckmessage}
      message={sneckmessage}
    />
    )}
<MenuBottAppBar value={'Energie'} />
</Container>

       
  );
};

export default EnergieDataDenEntity;
